export default __webpack_public_path__ + "static/media/Documenttation_page3.690dbd9f.svg";